const svgPlayIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="27px" height="27px"><path fill="#00aeef" d="M8 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18c.62-.39.62-1.29 0-1.69L9.54 5.98C8.87 5.55 8 6.03 8 6.82z"></path></svg>';
const svgPauseIcon =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" width="100" height="100"><line x1="4" y1="3" x2="4" y2="7" stroke="#00aeef" stroke-width="1"></line><line x1="6" y1="3" x2="6" y2="7" stroke="#00aeef" stroke-width="1"></line></svg>';

function carouselToggler(carousel, toggler) {
    const $carousel = $(carousel);
    const $toggler = $carousel.find(toggler);

    if ($toggler.hasClass('carousel-paused')) {
        $carousel.slick('slickPlay');
        $button.html(`${svgPauseIcon}`);
        $toggler.removeClass('carousel-paused');
    } else {
        $carousel.slick('slickPause');
        $button.html(`${svgPlayIcon}`);
        $toggler.addClass('carousel-paused');
    }
}

const landscapeSettings = {
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: 'linear',
    dots: true,
    arrows: false,
    speed: 600,
    dotsClass: 'landscape-carousel__dots',
};

$('.landscape-carousel')
    .on('init', function () {
        const $this = $(this);
        const $wrapper = $this.parent('.landscape-carousel__wrapper');
        const $dotsClass = `.${landscapeSettings.dotsClass}`;

        if ($wrapper.find($dotsClass).length) {
            $this
                .find($dotsClass)
                .wrap('<div class="landscape-carousel__controls" />');
        }

        adjustHeight($this.find('.landscape-carousel__caption-wrapper'));

        $(window).resize(() => {
            adjustHeight($this.find('.landscape-carousel__caption-wrapper'));
        });
    })
    .slick(landscapeSettings);

const $button = $('<button>')
    .attr('id', 'togglePlay')
    .addClass('btn btn__play')
    .html(`${svgPauseIcon}`);

$('.landscape-carousel__controls').append($button);

$button.on('click', function () {
    carouselToggler('.landscape-carousel', '#togglePlay');
});

function adjustHeight($elements) {
    let maxHeight = 0;

    $elements.height('auto').each(function () {
        const $element = $(this);

        if ($element.outerHeight() > maxHeight) {
            maxHeight = $element.outerHeight();
        }
    });

    $elements.height(maxHeight);
}

$('.quicklinks__tab-content').appendTo('.quicklinks__tabs');
